import { Action, Reducer } from 'redux';
import { AppThunkAction } from '.';
import { SessionModel, initialState } from '../models/SessionModel';
import {  ResetStore } from '../store/sawinLib'
import * as BillToMdls from '../models/BillToModel';
import { ServiceMaster as ServiceMasterMdl, initialState as SMInitialState} from '../models/ServiceMasterModel';

export interface SetValuesAction { type: 'SESSION_SET_VALUES', newState: SessionModel }
export interface SetSelectedAR { type: 'SESSION_SET_AR', AR: BillToMdls.BillToModel }
export interface SetSelectedSM { type: 'SESSION_SET_SM', SM: ServiceMasterMdl }

export type KnownAction = SetValuesAction | SetSelectedAR | SetSelectedSM | ResetStore;

export const actionCreators = {
    setSessionValues: (pState: SessionModel): AppThunkAction<KnownAction> => (dispatch, getState) => {                
        dispatch({ type: 'SESSION_SET_VALUES', newState: pState });
    },
    setSelectedAR: (ARNum: string): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const currentState = getState();
        const BillToList = currentState.billToList;
        if (BillToList !== undefined) {
            const BillToModel: BillToMdls.BillToModel | undefined = BillToList.items.find(element => element.id == ARNum);
           
            if (BillToModel !== undefined) {
                dispatch({ type: 'SESSION_SET_AR', AR: { ...BillToModel } });                
                dispatch({ type: 'SESSION_SET_SM', SM: { ...BillToModel.serviceMasters ? BillToModel.serviceMasters[0] : { ...SMInitialState }} });
                dispatch({ type: 'STORE_RESET' });
            }
        }
    },
    setSelectedSM: (SMNum: string): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const currentState = getState();
        const BillToList = currentState.billToList ;
        const SelectedAR = currentState.sessionState ? currentState.sessionState.SelectedAR : undefined ;        
        if (BillToList !== undefined) {
            const BillToModel: BillToMdls.BillToModel | undefined = BillToList.items.find(element => element.id == (SelectedAR ? SelectedAR.id : 0));            
            if (BillToModel !== undefined) {                                  
                const SMObj = BillToModel.serviceMasters.find(el => el.id == SMNum);                  
                dispatch({ type: 'SESSION_SET_SM', SM: { ...SMObj ? SMObj : { ...SMInitialState } } });
                dispatch({ type: 'STORE_RESET' });                
            }
        }        
    }

};


export const reducer: Reducer<SessionModel> = (state: SessionModel | undefined, incomingAction: Action): SessionModel => {

    if (state === undefined) {
        return initialState;
    }
    const action = incomingAction as KnownAction;    
    switch (action.type) {
        case 'SESSION_SET_VALUES':
            var myAction = incomingAction as SetValuesAction;
            return {
                ...state, ...{ ...myAction.newState  }
            };
        case 'SESSION_SET_AR':
            return { ...state, ...{ SelectedAR: (incomingAction as SetSelectedAR).AR } }
        case 'SESSION_SET_SM':            
            const orgStata = { ...state };
            const result = { ...state, ...{ SelectedSM: (incomingAction as SetSelectedSM).SM } };            
            return {                
                ...state, ...{ SelectedSM: (incomingAction as SetSelectedSM).SM } } 
        default:
            return state;
    }
}; 